import { css, html } from 'react-strict-dom';
import { Api, useApiCallable } from 'src/api';
import { Dropdown, Text } from 'src/components';
import { Model } from 'src/models';

type Skill = Api.Ticket.V_AvailableList['skills'][number];

type Props = {
  skills: ReadonlyArray<Skill>;
  user: Api.User.V_Self;
  onTaken: () => void;
};

function TakeItLabel({ onClick }: { onClick?: () => void }) {
  return (
    <html.span style={styles.label} onClick={onClick}>
      <Text typeface="body.small.medium" color="accent" noSelect>
        Take it
      </Text>
    </html.span>
  );
}

/**
 * Assigns the viewer to a skill nobody has picked up. Renders nothing when
 * there is nothing on the ticket they can do.
 */
export default function TakeItAction({ skills, user, onTaken }: Props) {
  const callApi = useApiCallable();
  const takeable = Model.TicketSkill.filterTakeableBy(skills, user);

  async function handleTake(skill: Skill) {
    await callApi(`/ticket-skills/${skill.id}`, {
      method: 'PATCH',
      jsonBody: { assignee: user['@id'] },
    });
    onTaken();
  }

  if (takeable.length === 0) return null;

  if (takeable.length === 1) {
    return <TakeItLabel onClick={() => handleTake(takeable[0])} />;
  }

  return (
    <Dropdown anchorSide="right" trigger={<TakeItLabel />}>
      <Dropdown.SectionHeader>Take which skill?</Dropdown.SectionHeader>
      {takeable.map((skill) => (
        <Dropdown.Row key={skill.id} onClick={() => handleTake(skill)}>
          <Text typeface="body.regular" color="neutral100">
            {Model.TicketSkill.getTypeName(skill.type)}
          </Text>
        </Dropdown.Row>
      ))}
    </Dropdown>
  );
}

const styles = css.create({
  label: {
    cursor: 'pointer',
    whiteSpace: 'nowrap',
  },
});
